export default "__VITE_ASSET__8b6ab313__"